<template>
    <div v-for="(year, yearIndex) in years" :key="yearIndex">
        <div class="calendar-list">
            <div class="calendar-list__inner">
                <div class="calendar-list__months" v-for="(month, monthIndex) in year.months" :key="monthIndex">
                    <div class="calendar-list-month">
                        <h2 class="calendar-list-month__title"><strong>{{ month.name }}</strong> {{ year.name }}</h2>
                        <div class="calendar-list-month__days">
                            <div v-for="(day, dayIndex) in month.days"
                                 :key="dayIndex"
                                 class="calendar-list-day"
                                 :id="`day-${formatDate(day.date, 'yyyy-MM-dd')}`">
                                <h3 class="calendar-list-day__title">
                                    <span class="calendar-list-day__day">{{ formatDate(day.date, 'EEE') }}</span>
                                    <span class="calendar-list-day__day--desktop">{{ formatDate(day.date, 'EEEE') }}</span>
                                    <span class="calendar-list-day__date">{{ formatDate(day.date, 'd') }}</span>
                                </h3>
                                <div class="calendar-list-day__events">
                                    <calendar-list-event
                                        v-for="event in day.events"
                                        :key="event.id"
                                        :event="event"
                                        :opendialog="opendialog"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { groupBy, map } from 'lodash';
import { format } from 'date-fns';
import { ref, defineComponent, watch } from 'vue';

export default defineComponent({
    name: 'CalendarList',
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        opendialog: {
            type: Function,
            required: true,
        }
    },
    setup(props) {
        const years = ref([]);
        const openDialog = ref(null);

        const computeYearsMonthsDays = (items) => {
            if (!items.length) {
                years.value = [];
                return;
            }

            const groupedDays = groupBy(items, item => item._auxiliary.group_by_day);

            const processedDays = map(groupedDays, (dayEvents, key) => ({
                date: dayEvents[0].performancedate,
                events: dayEvents,
                _auxiliary: dayEvents[0]._auxiliary,
            }));

            const groupedMonths = groupBy(processedDays, day => day._auxiliary.group_by_month);

            const processedMonths = map(groupedMonths, (monthDays, monthKey) => {
                const firstDay = monthDays[0];
                return {
                    name: format(firstDay.date, 'MMMM'),
                    monthKey: monthKey,
                    days: monthDays,
                    year: format(firstDay.date, 'yyyy'),
                    _auxiliary: firstDay._auxiliary,
                };
            });

            const groupedYears = groupBy(processedMonths, month => month.year);

            years.value = map(groupedYears, (yearMonths, yearKey) => ({
                name: yearKey,
                months: yearMonths.map(month => ({
                    name: month.name,
                    days: month.days
                }))
            })).sort((a, b) => a.name.localeCompare(b.name));
        };

        const formatDate = (date, formatStr) => {
            const dateObj = typeof date === 'string' ? new Date(date) : date;
            return format(dateObj, formatStr);
        };

        watch(
            [() => props.items, () => props.opendialog],
            ([newItems, newOpenDialog]) => {
                computeYearsMonthsDays(newItems);
                openDialog.value = newOpenDialog;
            },
            { immediate: true }
        );

        return {
            years,
            opendialog: openDialog,
            formatDate
        };
    },
});
</script>
